import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ScrollArea } from '../../../../components/ui/scroll-area';
import CollapsibleCard from '../../../../components/CollapsibleCard';
import TableViewEntry from './TableViewEntry';
import StackViewEntry from './StackViewEntry';
import constants from '../../../../commonUtils/constants';
import MismatchInfo from '../step3/MismatchInfo';

const ViewAdditionalFields = ({ hideFieldSelection = false, hideNavigationButtons = false }) => {
  const { additionalColumns, destinationDataTypes, errors } = useSelector((state) => state.Uploads);

  // Memoize the selected columns rendering logic
  const renderAdditionalColumns = useMemo(() => {
    if (!additionalColumns || additionalColumns.length === 0) return null;

    return additionalColumns.map((item, index) => {
      const hasDataTypeMismatch = item.Input_DataType !== item.Mapped_DataType &&
                                  item.Mapped_DataType !== "" &&
                                  item.Mapped_DataType !== "NA";

      const commonProps = {
        index,
        columns: additionalColumns.map(i => i.Input_Column),
        dataTypes: destinationDataTypes,
        source: item.Input_Column,
        sourceType: item.Input_DataType,
        destination: item.Mapped_Column,
        destType: item.Mapped_Column === constants.upload.matchNotFound ? "" : item.Mapped_DataType,
        addColumns: true,
        errors: errors?.additionalColumns?.[index] || []
      };

      return (
        <div
          key={item.Input_Column}
          className={`py-1 px-1 rounded ${hasDataTypeMismatch ? 'bg-yellow-200' : ''}`}
        >
          {/* Desktop view */}
          <div className="hidden md:block">
            <TableViewEntry
              {...commonProps}
            />
          </div>
          
          {/* Mobile view */}
          <div className="block md:hidden">
            <StackViewEntry
              {...commonProps}
            />
          </div>
        </div>
      );
    });
  }, [additionalColumns, destinationDataTypes, errors]);

  // Early return if additionalColumns is empty
  if (!additionalColumns || additionalColumns.length === 0) {
    return null;
  }
  
  return (
    <CollapsibleCard
      className="m-0"
      title="Additional Fields"
      showCollapseButton={true}
    >
      <div className="flex flex-col gap-2 h-full">
        <div className="flex flex-col flex-grow min-h-0">
          <p className="leading-4 border-b border-primary pb-3 font-bold mb-3">
            Fields Chosen For Creation
          </p>

          <ScrollArea className="flex-grow min-h-0">
            <div className="flex flex-col gap-2">
              {/* Header row - only show for desktop */}
              <div className="hidden md:block">
                <div className="grid grid-cols-3 gap-2 mt-2">
                  <p>Source (File Field)</p>
                  <p>Destination (DB Field)</p>
                  <p>Destination Data Type</p>
                </div>
              </div>
              
              {/* Render additional columns */}
              {renderAdditionalColumns}
            </div>
          </ScrollArea>
        </div>

      </div>
      <MismatchInfo className="items-start" />
    </CollapsibleCard>
  );
};

export default ViewAdditionalFields;